define('views/modules/calendar/nutrition/food/favorite/food-favorite-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // collections
    'collections/calendar/nutrition/food-favorites',
    // Views
    // 'views/parts/list/list',
    'views/parts/fetch-button',
    'views/modules/calendar/nutrition/food/food-content',
    'views/modules/calendar/nutrition/food/list/food-list',
    'views/modules/calendar/nutrition/food/favorite/list/food-favorite-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // collections
    CFoodFavorites,
    // Views
    // VList,
    VFetchButton,
    VFoodContent,
    VFoodList,
    VFoodFavoriteItem
) {

    var VFoodFavoriteContent = VFoodContent.extend({
        initialize: function(options) {
            this.collection = this.collection || new CFoodFavorites(null, _.extend({ full: true, pageSize: 250 }, _.pick(options, 'types')));
            // view = _.extend(this.view, {
            //     more: new VFetchButton({
            //         label: 'Show more',
            //         callback: this.onLoadMore,
            //         context: this,
            //         icon: 'sl-icon-arrow-down',
            //     })
            // });

            this.listenTo(this.favorite, {
                'sync': this.onFavoriteSync
            });
        },

        // render: function() {
        //   VFoodFavoriteContent.__super__.render.apply(this, arguments);
        //     this.assign(this.view.more, this.zone.$more);
        //     return this;
        // },

        _initList: function() {
            return new VFoodList({
                collection: this.collection,
                favorite: this.favorite,
                item: VFoodFavoriteItem,
                defaultServing: true,
                async: false
            });
        },

        onFavoriteSync: function() {
            this.collection.reset(this.favorite.models);
        },

        onLoadMore: function(e, callback) {
          // this.collection.state.pageSize = this.collection.state.pageSize + 20;
          //   this.collection.getFirstPage({ fetch: true, reset: true }).always(callback);
          //
          //   this._initList();
          //   this.render();
          //   this.renderList();
        },
    });

    return VFoodFavoriteContent;
});

